import { documentHasElements } from "modules/dom";

documentHasElements(".js-hero-scroll-container-block", (heroScrollContainerBlocks) => {
    heroScrollContainerBlocks.forEach((heroScrollContainerBlock) => {
        const sliderBlocksChildren = heroScrollContainerBlock.querySelectorAll<HTMLDivElement>(".slider__blocks > div");
        const outerEl = heroScrollContainerBlock.parentElement;
        if (!outerEl) return;

        const middleHeader = heroScrollContainerBlock.querySelector<HTMLElement>(".heading__middle");
        const sliderDots = heroScrollContainerBlock.querySelector<HTMLElement>(".slider__dots");

        const slides = Array.from(sliderBlocksChildren);
        const numSlides = slides.length;

        sliderBlocksChildren.forEach((block: HTMLDivElement, index: number) => {
            block.setAttribute("data-item", index.toString());

            const title = block.querySelector<HTMLHeadingElement>("h2");
            const image = block.querySelector<HTMLElement>(".col.image");
            const clone = image?.cloneNode(true) as HTMLElement | null;

            if (image) image.remove();

            const blockContainer = block.querySelector<HTMLElement>(".block");
            if (blockContainer && clone) blockContainer.prepend(clone);

            const listItem = document.createElement("li");

            if (index === 0) {
                listItem.classList.add("active");
            }

            listItem.setAttribute("data-item", index.toString());

            if (title) listItem.innerHTML = title.innerHTML;

            middleHeader?.appendChild(listItem);

            if (numSlides > 1) {
                const dotItem = document.createElement("li");

                if (index === 0) dotItem.classList.add("active");

                dotItem.setAttribute("data-item", index.toString());
                sliderDots?.appendChild(dotItem);
            }
        });

        // === Slide activation by absolute index ===
        let currentIndex = 0;

        function activateSlide(index: number) {
            if (index === currentIndex) return;

            heroScrollContainerBlock.querySelector(".slider__content.active")?.classList.remove("active");
            heroScrollContainerBlock.querySelector(".heading__middle .active")?.classList.remove("active");
            heroScrollContainerBlock.querySelector(".slider__dots .active")?.classList.remove("active");

            const target = slides[index] as HTMLElement;
            if (!target) return;

            target.classList.add("active");

            const sliderId = target.getAttribute("data-item");
            heroScrollContainerBlock
                .querySelector<HTMLElement>(`.heading__middle li[data-item="${sliderId}"]`)
                ?.classList.add("active");
            heroScrollContainerBlock
                .querySelector<HTMLElement>(`.slider__dots li[data-item="${sliderId}"]`)
                ?.classList.add("active");

            currentIndex = index;
        }

        // === Sticky + scroll-position-based slide detection (all screen sizes) ===
        let wrapperEl: HTMLDivElement | null = null;
        let scrollPerSlide = 500;

        const getHeaderHeight = (): number =>
            document.querySelector<HTMLElement>(".header")?.offsetHeight ?? 0;

        const setupSticky = () => {
            // Wrap outerEl in a scroll-space container on first setup
            if (!wrapperEl) {
                wrapperEl = document.createElement("div");
                wrapperEl.style.background = getComputedStyle(outerEl).backgroundColor;
                outerEl.parentNode?.insertBefore(wrapperEl, outerEl);
                wrapperEl.appendChild(outerEl);
            }

            const isMobile = window.innerWidth < 1024;
            scrollPerSlide = isMobile ? 350 : 500;
            const bufferAfterLast = isMobile ? 120 : scrollPerSlide;
            const outerHeight = outerEl.offsetHeight;
            const headerHeight = getHeaderHeight();
            const topOffset = headerHeight;

            wrapperEl.style.height = `${outerHeight + scrollPerSlide * (numSlides - 1) + bufferAfterLast}px`;
            outerEl.style.position = "sticky";
            outerEl.style.top = `${topOffset}px`;
        };

        const onScroll = () => {
            if (!wrapperEl) return;

            const wrapperRect = wrapperEl.getBoundingClientRect();
            const scrolledIn = -wrapperRect.top;

            if (scrolledIn < 0) return;

            const rawIndex = Math.floor(scrolledIn / scrollPerSlide);
            const newIndex = Math.max(0, Math.min(rawIndex, numSlides - 1));

            activateSlide(newIndex);
        };

        setupSticky();
        // Listeners are intentionally not removed: this is a full-page-reload site with no SPA navigation.
        // If lifecycle cleanup is ever needed, use window.removeEventListener("resize", setupSticky)
        // and window.removeEventListener("scroll", onScroll).
        window.addEventListener("resize", setupSticky, { passive: true });
        window.addEventListener("scroll", onScroll, { passive: true });
    });
});